import { useWatch } from 'react-hook-form';
import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormFieldState } from '../../hooks';

interface BottomBarProps {
  totalPSNo?: number;
  totalPSCo?: number;
  state: FormFieldState;
}

export function BottomBar({ totalPSNo = 0, totalPSCo = 0, state }: BottomBarProps) {
  const [ma_ngv] = useWatch({ name: ['ma_ngv'] });

  const ty_gia = state.ty_gia;
  const isVND = ty_gia == 1;
  const isAm = ma_ngv === '1';
  const displayTotalPSNo = isAm ? -Math.abs(Number(totalPSNo)) : totalPSNo;
  const displayTotalPSCo = isAm ? -Math.abs(Number(totalPSCo)) : totalPSCo;

  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className=''>
        <div className='ml-4 flex flex-col'>
          <div className='flex items-center gap-4'>
            <Label className='w-24 font-bold'>Tổng ps nợ</Label>
            <FormField
              name='t_ps_no_nt'
              type='text'
              value={formatRoundedNumber(displayTotalPSNo)}
              className='min-w-36'
            />
            <FormField
              name='t_ps_no'
              className={isVND ? 'hidden' : 'min-w-36 font-semibold'}
              type='text'
              value={formatRoundedNumber(displayTotalPSNo * ty_gia)}
            />
          </div>
        </div>

        <div className='ml-4 flex flex-col'>
          <div className='flex items-center gap-4'>
            <Label className='w-24 font-bold'>Tổng ps có</Label>
            <FormField
              name='t_ps_co_nt'
              type='text'
              value={formatRoundedNumber(displayTotalPSCo)}
              className='min-w-36'
            />
            <FormField
              name='t_ps_co'
              className={isVND ? 'hidden' : 'min-w-36 font-semibold'}
              type='text'
              value={formatRoundedNumber(displayTotalPSCo * ty_gia)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
